export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10467.8bc6587b.jpg";